const MARKETING_SOURCES = Object.freeze([
  "google",
  "bing",
  "instagram",
  "facebook",
  "boletin",
  "libreria-local",
  "google-business-profile",
])

const MARKETING_MEDIA = Object.freeze([
  "organic",
  "organic-social",
  "paid-social",
  "cpc",
  "email",
  "qr",
  "referral",
])

// Add only reviewed campaigns here, test them, deploy them, and only then
// distribute their URLs. Values are stored in their canonical normalized form.
const MARKETING_CAMPAIGNS = Object.freeze([
  Object.freeze({
    source: "google",
    medium: "organic",
    campaign: "gbp-primaria",
    contents: Object.freeze([]),
    status: "active",
  }),
])

module.exports = {
  MARKETING_CAMPAIGNS,
  MARKETING_MEDIA,
  MARKETING_SOURCES,
}
